import { io, type Socket } from 'socket.io-client';
import { useEffect } from 'react';
import { SOCKET_EVENT_CHANNEL, type DataChangedEvent } from '@incidents/contracts';

// Single shared socket. The server places this connection into the tenant's room
// based on the Host header — we don't need to send anything tenant-aware ourselves.
let socket: Socket | null = null;

function getSocket(): Socket {
  if (socket && socket.connected) return socket;
  socket = io({ transports: ['websocket', 'polling'] });
  return socket;
}

export function useDataChanged(onChange: (event: DataChangedEvent) => void): void {
  useEffect(() => {
    const s = getSocket();
    const handler = (evt: DataChangedEvent) => onChange(evt);
    s.on(SOCKET_EVENT_CHANNEL, handler);
    return () => {
      s.off(SOCKET_EVENT_CHANNEL, handler);
    };
  }, [onChange]);
}
